import React from 'react';
import { Link } from 'react-router-dom';
import MockupShell from './MockupShell';

const TOOLS = [
  { to: '/mockups/lead-capture', name: 'Lead Capture Templates', sub: 'Pre-built pages you clone and publish.',                state: 'live',   tier: 'ROOKIE+' },
  { to: null,                    name: 'Page Builder',           sub: 'Drag-drop builder for custom landing pages.',           state: 'live',   tier: 'ROOKIE+' },
  { to: '/mockups/link-file',    name: 'Link File',              sub: 'Organize every link you share in one place.',           state: 'live',   tier: 'ALL'    },
  { to: '/mockups/rotator',      name: 'Rotator / Split-Test',   sub: 'One short URL, multiple destinations, click counts.',   state: 'live',   tier: 'ROOKIE+' },
  { to: null,                    name: 'QR Generator',           sub: 'Generate branded QR codes for your links.',             state: 'live',   tier: 'ALL'    },
  { to: '/mockups/credits',      name: 'Ad Credits Wallet',      sub: 'Spend on placements in the Marketing Library.',         state: 'live',   tier: 'ALL'    },
  { to: null,                    name: 'Marketing Library',      sub: 'Banners, swipes, scripts, and ad creatives.',           state: 'live',   tier: 'ROOKIE+' },
  { to: '/mockups/training',     name: 'Training Vault',         sub: 'Founder-led training modules with progress.',           state: 'live',   tier: 'ALL'    },
  { to: '/mockups/safe-list',    name: 'Safe List / Mailer',     sub: 'Member-to-member mailer with compliance rules.',        state: 'live',   tier: 'ROOKIE+' },
  { to: null,                    name: 'Network Feed',           sub: 'Public posts and updates from active builders.',        state: 'live',   tier: 'ALL'    },
  { to: null,                    name: 'Tool Store',             sub: 'Buy access to advanced builder tools.',                 state: 'live',   tier: 'PRO+'   },
  { to: null,                    name: 'Tool Inventory',         sub: 'Track tools, licenses, and expirations.',               state: 'live',   tier: 'PRO+'   },
  { to: null,                    name: 'Game Dashboard',         sub: 'Visual builder city. Earn tools through activity.',     state: 'soon',   tier: '—'      },
  { to: null,                    name: 'Internal Mailbox',       sub: 'Direct member-to-member messages.',                     state: 'soon',   tier: '—'      },
  { to: null,                    name: 'Self-Service Tier Upgrade', sub: 'Upgrade to PRO/ENTERPRISE via TRC-20 invoice.',       state: 'soon',   tier: '—'      },
];

export default function ToolStore() {
  return (
    <MockupShell
      title="Tools &amp; Services Hub"
      subtitle="Every builder tool in BBC Quick List, in one place. Locked items unlock as you progress."
      dataTestId="mockup-tools"
    >
      <div className="mk-compliance" style={{ marginBottom: 16 }}>
        <strong>Tier-gated access.</strong> Some tools require ROOKIE (5+ Pay-It-Forwards given) or
        PRO. Upgrades happen through your normal builder activity — and, after launch, optionally
        via a TRC-20 invoice paid directly through NowPayments. The platform never collects pooled
        money from members.
      </div>

      <div className="mk-grid mk-grid--3">
        {TOOLS.map((t, i) => {
          const inner = (
            <>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6, marginBottom: 8 }}>
                <h3 style={{ margin: 0, fontSize: 14 }}>{t.name}</h3>
                {t.state === 'live'
                  ? <span className="mk-badge mk-badge--gold">{t.tier}</span>
                  : <span className="mk-badge mk-badge--muted">Coming soon</span>}
              </div>
              <p style={{ margin: 0, fontSize: 12, color: 'var(--mk-muted)', lineHeight: 1.5 }}>{t.sub}</p>
              <div style={{ marginTop: 12 }}>
                {t.state === 'live' && (
                  t.to
                    ? <button className="mk-btn mk-btn--gold-outline">Open</button>
                    : <button className="mk-btn mk-btn--ghost">Open</button>
                )}
                {t.state === 'soon' && (
                  <button className="mk-btn mk-btn--disabled" disabled>Locked · Phase 2</button>
                )}
              </div>
            </>
          );
          const cardStyle = {
            display: 'flex',
            flexDirection: 'column',
            opacity: t.state === 'soon' ? 0.78 : 1,
            textDecoration: 'none',
            color: 'inherit',
          };
          return t.to ? (
            <Link key={t.name} to={t.to} className="mk-card" style={cardStyle} data-testid={`tool-card-${i}`}>{inner}</Link>
          ) : (
            <div key={t.name} className="mk-card" style={cardStyle} data-testid={`tool-card-${i}`}>{inner}</div>
          );
        })}
      </div>
    </MockupShell>
  );
}
